import { configureStore } from '@reduxjs/toolkit';
import emailReducer from '../features/email/emailSlice';

const store = configureStore({
  reducer: {
    email: emailReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
